import React, { useState, useEffect } from "react";
import "./App.css";
import Cardvereador from "./Componetes/CardVereador/VereadorCard.jsx";
import BiografiaVereador from "./Componetes/Biografia/Bio.jsx";
import { biografias } from "./dados/dadosVereadores.js";
import { proposicoes as originalProposicoes } from "./dados/proposicoes.js";
import { useLocalIP } from "./utils/useLocalIP.js";
import { Grid2, Typography, Divider } from "@mui/material";

const imgFromCod = (cod) => `/assets/${String(cod).padStart(2, "0")}.webp`;

const initialCandidates = [
  { cod: "1",  name: "Alex Melo", party: "PRD" },
  { cod: "2",  name: "Anderson de Tuca", party: "União Brasil" },
  { cod: "4",  name: "Binho", party: "Podemos" },
  { cod: "5",  name: "Breno Garibalde", party: "PSB" },
  { cod: "6",  name: "Camilo Daniel", party: "PT" },
  { cod: "7",  name: "Elber Batalha", party: "PSB" },
  { cod: "8",  name: "Fábio Meireles", party: "PDT" },
  { cod: "9",  name: "Iran Barbosa", party: "PSOL" },
  { cod: "10", name: "Isac", party: "União Brasil" },
  { cod: "11", name: "Joaquim da Janelinha", party: "PDT" },
  { cod: "12", name: "Levi Oliveira", party: "PP" },
  { cod: "13", name: "Lúcio Flávio", party: "PL" },
  { cod: "14", name: "Maurício Maravilha", party: "União Brasil" },
  { cod: "15", name: "Miltinho Dantas", party: "PSD" },
  { cod: "16", name: "Moana Valadares", party: "PL" },
  { cod: "27", name: "Nitinho", party: "PSD" },               // <-- era 16
  { cod: "17", name: "Pastor Diego", party: "União Brasil" },        // <-- empurrou 1
  { cod: "18", name: "Professora Sonia Meire", party: "PSOL" },
  { cod: "19", name: "Ricardo Vasconcelos", party: "PSD" },
  { cod: "20", name: "Rodrigo Fontes", party: "PSB" }, 
  { cod: "21", name: "Sávio Neto de Vardo", party: "Podemos" },
  { cod: "22", name: "Selma França", party: "PSD" },
  { cod: "23", name: "Sgt. Byron Estrelas do Mar", party: "MDB" },
  { cod: "24", name: "Soneca", party: "PSD" },
  { cod: "25", name: "Thannata da Equoterapia", party: "Mobiliza" },
  { cod: "26", name: "Vinicius Porto", party: "PDT" },
];

// Licenciados com cods corretos (batendo com os arquivos 27.webp, 28.webp e 21.webp)
const vereadoresLicenciados = [
  // { cod: "27", name: "Nitinho", party: "PSD" },
  // { cod: "28", name: "Dr. Manuel Marcos", party: "PSD" },
];

const vereadoresParticiparam = [
  { cod: "29", name: "Marcel Azevedo", party: "PSB" },
  { cod: "30", name: "Avilé Dantas", party: "PP" }
];

function App() {
  const localIP = useLocalIP();
  const [selectedVereador, setSelectedVereador] = useState(null);
  const [proposicoes, setProposicoes] = useState(originalProposicoes);

  useEffect(() => {
    if (!localIP) return;
    if (localIP === "190.15.122.10") {
      const updated = originalProposicoes.map((p) => ({
        ...p,
        link: p.link.includes("190.15.122.10")
          ? p.link.replace("190.15.122.10", "172.16.0.153")
          : p.link,
      }));
      setProposicoes(updated);
    }
  }, [localIP]);

  const handleMenuClick = (option, cod) => {
    if (option === "biografia") {
      const vereador = biografias.find((b) => String(b.cod) === String(cod));
      setSelectedVereador(vereador || null);
    } else if (option === "proposicoes") {
      const prop = proposicoes.find((p) => String(p.cod) === String(cod));
      if (prop?.link) window.open(prop.link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div>
      {selectedVereador ? (
        <BiografiaVereador {...selectedVereador} onBack={() => setSelectedVereador(null)} />
      ) : (
        <div>
          <Typography variant="h4" align="center" gutterBottom sx={{ mt: 3, mb: 3, color: "#fff", fontWeight: "bold", fontSize: 35 }}>
            Parlamentares da 44ª Legislatura - 1º Biênio (2025 - 2026)
          </Typography>

          {/* ATIVOS */}
          <Grid2 container spacing={3} justifyContent="center">
            {initialCandidates.map((v) => {
              const proposicao = proposicoes.find((p) => String(p.cod) === String(v.cod));
              return (
                <Grid2 item xs={12} sm={6} md={4} lg={3} key={v.cod}>
                  <Cardvereador
                    nome={v.name}
                    partido={v.party}
                    imagem={imgFromCod(v.cod)}  // 👈 agora sempre certo
                    proposicoes={proposicao}
                    onMenuClick={(option) => handleMenuClick(option, v.cod)}
                  />
                </Grid2>
              );
            })}
          </Grid2>

            <div style={{ marginTop: 40 }} />

          {/* LICENCIADOS — só aparece se houver alguém na lista */}
          {vereadoresLicenciados.length > 0 && (
            <>
              <Divider sx={{ width: "80%", mx: "auto", my: 5, backgroundColor: "#FFD700", height: 1 }} />

              <Typography variant="h4" align="center" sx={{ mb: 2, color: "#fff", fontWeight: "bold", fontSize: 35 }}>
                Parlamentares Licenciados
              </Typography>

              <Grid2 container spacing={3} justifyContent="center" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Grid2 item>
                  <Grid2 container spacing={3} justifyContent="center" sx={{ p: 2, mb: 6 }}>
                    {vereadoresLicenciados.map((v) => {
                      const proposicao = proposicoes.find((p) => String(p.cod) === String(v.cod));
                      return (
                        <Grid2 item xs={12} sm={6} md={4} lg={3} key={v.cod}>
                          <Cardvereador
                            nome={v.name}
                            partido={v.party}
                            imagem={imgFromCod(v.cod)}
                            proposicoes={proposicao}
                            onMenuClick={(option) => handleMenuClick(option, v.cod)}
                          />
                        </Grid2>
                      );
                    })}
                  </Grid2>
                </Grid2>
              </Grid2>
            </>
          )}

          <Divider sx={{ width: "80%", mx: "auto", my: 5, backgroundColor: "#FFD700", height: 1 }} />
          {/* PARTICIPARAM */}


         {/* PARTICIPARAM */}
          <Typography variant="h4" align="center" sx={{ mb: 2, color: "#fff", fontWeight: "bold", fontSize: 35 }}>
            Parlamentares que participaram dessa Legislatura
          </Typography>

          <Grid2 container spacing={3} justifyContent="center" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Grid2 item>
              <Grid2 container spacing={3} justifyContent="center" sx={{ p: 2, mb: 6 }}>
                {vereadoresParticiparam.map((v) => {
                  const proposicao = proposicoes.find((p) => String(p.cod) === String(v.cod));
                  return (
                    <Grid2 item xs={12} sm={6} md={4} lg={3} key={v.cod}>
                      <Cardvereador
                        nome={v.name}
                        partido={v.party}
                        imagem={imgFromCod(v.cod)}  // ❗ removeu o "-1"
                        proposicoes={proposicao}
                        onMenuClick={(option) => handleMenuClick(option, v.cod)}
                      />
                    </Grid2>
                  );
                })}
              </Grid2>
            </Grid2>
          </Grid2>

        </div>
      )}
    </div>
  );
}

export default App;
